import { SafePromise } from '@benzinga/safe-await';
import { Subscribable, SubscribableEventType, Subscription } from '@benzinga/subscribable';
import { CurrencyPairQuote, ExchangeRatesResponse } from './entities';
import { Session } from '@benzinga/session';
import { ForexRequest } from './request';

export class ForexManager extends Subscribable<SubscribableEventType<ForexRequest>> {
  private request: ForexRequest;
  private requestSubscription?: Subscription<ForexRequest>;

  constructor(session: Session) {
    super();
    this.request = new ForexRequest(session);
  }

  public static getName = () => 'benzinga-forex-quotes';

  public getCurrencyPairQuote = async (currencyPair: string): SafePromise<CurrencyPairQuote> => {
    return await this.request.getCurrencyPairQuote(currencyPair);
  };

  public getExchangeRates = async (currency = 'USD'): SafePromise<ExchangeRatesResponse> => {
    return await this.request.getExchangeRates(currency);
  };

  protected onFirstSubscription(): void {
    this.requestSubscription = this.request.listen(event => this.dispatch(event));
  }

  protected onZeroSubscriptions(): void {
    this.requestSubscription?.unsubscribe();
  }
}
